/* eslint-disable no-unused-vars */

import SnapSlider from '@tannerhodges/snap-slider';

import sliderControl from '@utils/slider-controls'
import roundPrices from '@utils/intl'
import seoTextTrigger from '@utils/seo-text'

import {
  unAddScrollWrap,
  checkHeightTextSize,
  imitateHover,
  unSimpleAccardion,
  checkAndCreateDots,
  checkAndCreateDotsBlueBar,
  generateTextAnchors,
  mobileFlipper,
  prettyMobHeader,
  hiddenCategoryBlogWrap,
  scrolly,
  unAddStickyProductTabs,
  changeSellerText,
  antiMobileFlipper,
  themeAccordions,
  simpleReadMore,
  unFatMenuPosition,
} from './ui-scripts'
import { unSimpleHoverTimeout, unAnchorScrollTo, activeFilterClass, hiddenArrowsWhenNotEnoughLength } from './un-ui-scripts'

import Swipe from './swipe'
import { onAppMounted } from './app-mounted'

const NON_TOUCH = 0

// Works on the DOM Vue renders, so it waits for the mount (see app-mounted.js).
onAppMounted(() => {
  unAddScrollWrap('un-categories_for_slider_desktop', 'category-swipe-wrapper')
  unAddScrollWrap('js-partners-wrap', 'js-partners-single')
  checkHeightTextSize()
  generateTextAnchors()
  imitateHover()
  checkAndCreateDotsBlueBar()
  hiddenCategoryBlogWrap()
  unFatMenuPosition()
  unAddStickyProductTabs()
  unSimpleAccardion()
  checkAndCreateDots()
  hiddenArrowsWhenNotEnoughLength()
  activeFilterClass('.un-tabs-wrap-parent', '.un-tabs-wrap', '#header-wrap', 'active-sticky', 'active-product-menu', false);
  activeFilterClass()
  unAnchorScrollTo()
  simpleReadMore()
  unSimpleHoverTimeout()
  roundPrices()
  seoTextTrigger()
  // burgerMenuToogle()
  // if (
  //   navigator.maxTouchPoints > NON_TOUCH ||
  //   navigator.msMaxTouchPoints > NON_TOUCH
  // ) {
  //   mobileFlipper()
  // }
  scrolly()
  prettyMobHeader()
  sliderControl()
  changeSellerText()
  // document.addEventListener('click', antiMobileFlipper)
  themeAccordions()
  const ZERO = 0
  if (
    navigator.maxTouchPoints === ZERO ||
    navigator.msMaxTouchPoints === ZERO
  ) {
    const box = document.getElementById('slider');
    // SWIPE INITIALIZATION
    const swipe = new Swipe(box, {
      corners: true,
      minDistance: 50,
    });
    // const afterEvent = swipe.addEventListener('after', direction => {
    //   console.log(direction);
    //   // runAnimation(direction);
    // });
    const liveEvent = swipe.addEventListener('live', (direction, distance) => {
      // runAnimation(direction);
      if ('left' === direction) {
        box.scrollLeft += distance
      } else if ('right' === direction) {
        box.scrollLeft -= distance
      }
    })
  }

  const sliders = Array.from(document.getElementsByClassName('js-slider-autoplay'))
  sliders.forEach(slider => {
    setInterval(() => {
      if (!slider.SnapSlider) return
      slider.SnapSlider.goto('next', { focus: false })
      // console.log(slider.SnapSlider.getCurrentSlide());
    }, 5000)
  })
})
